module.exports = __webpack_public_path__ + "static/media/vallen-favicon.c3e5b701.png";